import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { colors } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  lowercaseValue: {
    textTransform: 'lowercase'
  },
  noError: {
    color: 'green',
    marginLeft: theme.spacing(3),
  },
  error: {
    color: 'red',
    marginLeft: theme.spacing(3),
  },
  helpHotline: {
    color: 'black',
    fontWeight: 400,
  },
  warning: {
    color: 'blue',
    fontWeight: 200,
    marginLeft: theme.spacing(3),
  },
  DialogFont: {
    color: colors.grey[900],
    // color: 'black',
  }
}));

export const Questions = ({ disabledValue, values, nationality, idType, depositValue, sourcesOfIncome, signingMandate, errors, selectedValue, policy }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  // const [data, setData] = useState([]);
  // const [errorValue, setValue] = useState([]);

  // useEffect(() => {
  //   handleStateError()
  // }, [])  

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  
  const BankBoolean = depositValue === 'b' && (values.bankNameDeposit === '' || values.depositAccountNames === '' || values.depositAccountNumber === '');
  const telecomBoolean = depositValue === 't' && (values.telecomName === '' || values.registeredNames === '' || values.registeredNumber === '');

  
  const newError = {}
  const returnedTarget = Object.assign(newError, errors);
  delete returnedTarget.otherSigningMandate;
  delete returnedTarget.othersourcesOfIncome;
  delete returnedTarget.currentEmployer;

  // const handleStateError = () =>{
    const errorData = Object.values(returnedTarget)
  //   setValue(errorData);
  // }

  return (
    <div className={classes.root}>
      {disabledValue === true ? (
        <Tooltip title="Click to view some answered questions" arrow placement="top">
          <div className="fab-container">
          <Fab color="primary" className="fab-button" onClick={handleClickOpen}>
            Help
          </Fab>
          </div>
        </Tooltip>
      ) : ''}

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        className={classes.DialogFont}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Frequently Asked Questions"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>1. Why I'm I unable to preview and submit my data?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <li>The usual cause of the disabled preview and submit button is existence of errors in the form. </li><br />
                  <li>Alternatively, you could be having missing information.</li><br />
                  <li>Below is a list of all errors that Post Bank Ltd has identified. The errors will clear as you correctly fill the form.</li><br />
                  <><b>Identified Form Errors:</b><br /></>
                  {errorData.length === 0 ? (<><span className={classes.noError}>You have not caused any form Errors<br /></span><br /></>) :
                    errorData.map((value, index, array) => {
                      return (
                        <> <span className={classes.error} key={index}>{index + 1}. {value}</span><br /></>)
                    })}
                  {policy === false || telecomBoolean === true || BankBoolean === true || selectedValue === '' || (sourcesOfIncome === 'S' && ("currentEmployer" in errors) === true) || (signingMandate === 'OT' &&
                   ("otherSigningMandate" in errors) === true) || (sourcesOfIncome === 'OT' && ("othersourcesOfIncome" in errors) === true) || (nationality ==='UG' && idType !=='N')?
                    (<><br /><b>Other Errors:</b><br /></>) : ''}
                  {
                    policy === false ? (
                      <>
                        <span className={classes.error}>* Ensure that you have checked the box after filling in your contact information</span><br></br>
                      </>
                    ) : null}
                    {/* nationality ==='UG' && idType !=='N' */}
                  {
                    nationality ==='UG' && idType !=='N' ? (
                      <>
                        <span className={classes.error}>* If your nationality is Ugandan, Ensure that you have selected the ID-Type as National ID. Also Ensure that you have provide your valid NIN and Expiry Date of the ID.</span><br></br>
                      </>
                    ) : null}
                  {selectedValue === '' ? (
                    <>
                      <span className={classes.error}>* Ensure that you have selected the Deposit Protection Fund</span><br />
                    </>
                  ) : null}
                  {signingMandate === 'OT' && ("otherSigningMandate" in errors) === true? (
                    <>
                      <span className={classes.error}>* Ensure that you have filled in your Other Signing Mandate correctly</span><br />
                    </>
                  ) : ''}
                  {sourcesOfIncome === 'OT' && ("othersourcesOfIncome" in errors) === true? (
                    <>
                    <span className={classes.error}>* Ensure that you have filled in your Other Source of Income correctly</span><br />
                    </>
                  ) : ''} 
                  {sourcesOfIncome === 'S' && ("currentEmployer" in errors) === true? (
                    <>
                    <span className={classes.error}>* Ensure that you have filled in your Current Employer correctly</span><br />
                    </>
                  ) : ''}
                  {BankBoolean === true? (
                    <>
                    <span className={classes.error}>* Ensure that you have filled in your Bank details for the Deposit Protection fund</span><br />
                    </>
                  ) : ''}
                  {telecomBoolean === true? (
                    <>
                    <span className={classes.error}>* Ensure that you have filled in your Telecom details for the Deposit Protection fund</span><br />
                    </>
                  ) : ''}
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={classes.heading}>2. Where can I find my Form ID</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <li>You can highlight the form ID at the top of the page and copy it. </li><br />
                  <li>Alternativley, just click on the
                  button next to the form ID and it will automatically copy it to the clipboard. </li><br />
                  <li>Be sure to paste it somewhere safe.</li><br />
                  <li>You can send yourself an email so that it's safe.</li>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography className={classes.heading}>3. Can I fill out this form on another device?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <li>Yes, you can access the form from any device of your choice. As long as the device is internet enabled and
                  has a browser.</li>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography className={classes.heading}>4. What is the best browser to use while accessing the form?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  The best experience reported has so far been with Google Chrome with a zoom of 90%. However, other browsers work just fine.
          </Typography>
              </AccordionDetails>
            </Accordion>
            <br />
           If the issues persist, please contact the help center on this toll free line below; <br/> <span className={classes.helpHotline}>+256-800-217-200</span>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default Questions;